import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { finalize } from 'rxjs/operators'

import { ResultCode } from '../../../domain/authentication.model'
import { AuthService } from '../../../services/auth.service'
import { NotificationService } from '../../../services/notification.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-new-password-form',
  templateUrl: './bmcore-new-password-form.component.html',
  styleUrls: ['./bmcore-new-password-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreNewPasswordFormComponent implements OnInit {
  lg: LgType
  newPasswordForm: UntypedFormGroup
  code: string
  isLoader = false

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    private formBuilder: UntypedFormBuilder,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.code = this.activatedRoute.snapshot.queryParams['code']

    this.newPasswordForm = this.formBuilder.group({
      password: [],
      confirmPassword: []
    })
  }

  onSubmit() {
    if (this.newPasswordForm.valid) {
      const { password, confirmPassword } = this.newPasswordForm.value

      if (password.password === confirmPassword.confirmPassword) {
        this.isLoader = true

        this.authService
          .changePassword(password.password, this.code)
          .pipe(finalize(() => (this.isLoader = false)))
          .subscribe(
            res => {
              if (res.resultCode === ResultCode.Success) {
                this.authService.me()
                this.router.navigate([''])
              } else {
                this.notificationService.handleError(res.messages[0])
              }
            },
            err => this.notificationService.handleError(err.message)
          )
      } else {
        this.notificationService.handleError(this.lg.forms.passwordsDontMatch)
      }
    } else {
      this.notificationService.handleError(this.lg.forms.error)
    }
  }
}
